import React, { useEffect, useState, useCallback } from 'react';
import { createRoot } from 'react-dom/client';
import { get, post, put } from './api';
import { t, LanguageSwitcher } from '@omnifuse/shared/frontend/i18n';
import { SettingsPanel } from '@omnifuse/shared/frontend/SettingsPanel';
import { get as apiGet, post as apiPost, put as apiPut } from './api';

const S = {
  page: { maxWidth: 1150, margin: '0 auto', padding: 24 } as React.CSSProperties,
  card: { background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,.08)', marginBottom: 16 } as React.CSSProperties,
  btn: { padding: '6px 14px', borderRadius: 8, border: '1px solid #ccc', background: '#fff', cursor: 'pointer', fontSize: 13 } as React.CSSProperties,
  btnPrimary: { padding: '6px 14px', borderRadius: 8, border: 'none', background: '#1a73e8', color: '#fff', cursor: 'pointer', fontSize: 13 } as React.CSSProperties,
  table: { width: '100%', borderCollapse: 'collapse' as const, fontSize: 13 },
  th: { textAlign: 'left' as const, padding: '8px 10px', borderBottom: '2px solid #eee', color: '#555', whiteSpace: 'nowrap' as const },
  td: { padding: '8px 10px', borderBottom: '1px solid #f0f0f0' },
  tab: (a: boolean) => ({ padding: '8px 18px', cursor: 'pointer', borderBottom: a ? '2px solid #1a73e8' : '2px solid transparent', color: a ? '#1a73e8' : '#555', fontWeight: a ? 600 : 400, fontSize: 14 }) as React.CSSProperties,
  input: { padding: '6px 10px', borderRadius: 6, border: '1px solid #ccc', fontSize: 13 } as React.CSSProperties,
};

// ═══ 广告系列 ═══
function CampaignsView() {
  const [rows, setRows] = useState<any[]>([]);
  const [form, setForm] = useState({ platform: 'meta', name: '', daily_budget: 50, utm_campaign: '' });
  const [busy, setBusy] = useState(false);

  const load = () => get('/api/v1/campaigns').then((r: any) => setRows(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name) return alert('请填写系列名称');
    try { await post('/api/v1/campaigns', form); setForm({ ...form, name: '', utm_campaign: '' }); load(); }
    catch (e: any) { alert(e.message); }
  };

  const recordToday = async (cp: any) => {
    const spend = prompt(`${cp.name} 今日花费 $？`);
    if (spend === null) return;
    const clicks = prompt(t('点击数？'), '0');
    try {
      await post(`/api/v1/campaigns/${cp.id}/metrics`, {
        date: new Date().toISOString().split('T')[0],
        spend: Number(spend), clicks: Number(clicks || 0),
      });
      alert('已记录'); load();
    } catch (e: any) { alert(e.message); }
  };

  const scanAttr = async () => {
    setBusy(true);
    try { const r: any = await post('/api/v1/attribution/scan'); alert(`扫描 ${r.data.orders_scanned} 单，归因 ${r.data.attributed} 单`); load(); }
    catch (e: any) { alert(e.message); }
    setBusy(false);
  };

  return (
    <>
      <div style={S.card}>
        <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
          <select style={S.input} value={form.platform} onChange={e => setForm({ ...form, platform: e.target.value })}>
            <option value="meta">Meta Ads</option><option value="google">Google Ads</option>
          </select>
          <input style={{ ...S.input, flex: 1 }} placeholder={t('系列名称')} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          <input style={{ ...S.input, width: 110 }} type="number" title={t('日预算')} value={form.daily_budget} onChange={e => setForm({ ...form, daily_budget: Number(e.target.value) })} />
          <input style={{ ...S.input, width: 180 }} placeholder={t('utm_campaign（归因匹配）')} value={form.utm_campaign} onChange={e => setForm({ ...form, utm_campaign: e.target.value })} />
          <button style={S.btnPrimary} onClick={add}>{t('添加')}</button>
          <button style={{ ...S.btnPrimary, background: '#188038' }} disabled={busy} onClick={scanAttr}>{busy ? '归因中...' : t('🔗 订单归因')}</button>
        </div>
      </div>
      <div style={S.card}>
        <table style={S.table}>
          <thead><tr>
            <th style={S.th}>{t('系列')}</th><th style={S.th}>{t('平台')}</th><th style={S.th}>{t('日预算')}</th>
            <th style={S.th}>{t('7天花费')}</th><th style={S.th}>{t('7天收入')}</th><th style={S.th}>ROAS</th><th style={S.th}>{t('状态')}</th><th style={S.th}></th>
          </tr></thead>
          <tbody>
            {rows.map((r: any) => (
              <tr key={r.id}>
                <td style={S.td}>{r.name}</td>
                <td style={S.td}>{r.platform}</td>
                <td style={S.td}>${r.daily_budget}</td>
                <td style={S.td}>${(r.spend_7d || 0).toFixed(0)}</td>
                <td style={S.td}>${(r.revenue_7d || 0).toFixed(0)}</td>
                <td style={{ ...S.td, fontWeight: 700, color: r.roas_7d === null ? '#888' : r.roas_7d >= 3 ? '#188038' : r.roas_7d >= 1.5 ? '#e8710a' : '#d93025' }}>
                  {r.roas_7d ?? '-'}
                </td>
                <td style={S.td}>{r.status}</td>
                <td style={{ ...S.td, whiteSpace: 'nowrap' }}>
                  <span style={{ display: 'inline-flex', gap: 6 }}>
                    <button style={S.btn} onClick={() => recordToday(r)}>{t('录入指标')}</button>
                    <button style={S.btn} onClick={async () => { await put(`/api/v1/campaigns/${r.id}`, { status: r.status === 'active' ? 'paused' : 'active' }); load(); }}>
                      {r.status === 'active' ? '暂停' : t('恢复')}
                    </button>
                  </span>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td style={S.td} colSpan={8}>{t('暂无广告系列')}</td></tr>}
          </tbody>
        </table>
      </div>
    </>
  );
}

// ═══ 预算调优 ═══
function OptimizerView() {
  const [actions, setActions] = useState<any[]>([]);
  const [busy, setBusy] = useState(false);

  const load = () => get('/api/v1/optimizer/actions').then((r: any) => setActions(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const run = async () => {
    setBusy(true);
    try { const r: any = await post('/api/v1/optimizer/run'); alert(`评估 ${r.data.campaigns_evaluated} 个系列，生成 ${r.data.suggestions} 条建议`); load(); }
    catch (e: any) { alert(e.message); }
    setBusy(false);
  };

  const act = async (id: string, action: 'approve' | 'reject') => {
    try { await post(`/api/v1/optimizer/actions/${id}/${action}`); load(); } catch (e: any) { alert(e.message); }
  };

  const ACTION_NAMES: Record<string, string> = { increase: t('⬆ 提额'), decrease: t('⬇ 降额'), pause: t('⏸ 暂停'), resume: t('▶ 恢复') };

  return (
    <div style={S.card}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <h3 style={{ fontSize: 15 }}>{t('预算调优建议')}</h3>
        <button style={S.btnPrimary} disabled={busy} onClick={run}>{busy ? '评估中...' : t('⚡ 运行调优引擎')}</button>
      </div>
      <table style={S.table}>
        <thead><tr>
          <th style={S.th}>{t('系列')}</th><th style={S.th}>{t('动作')}</th><th style={S.th}>{t('预算变化')}</th>
          <th style={S.th}>{t('原因')}</th><th style={S.th}>{t('状态')}</th><th style={S.th}>{t('操作')}</th>
        </tr></thead>
        <tbody>
          {actions.map((a: any) => (
            <tr key={a.id}>
              <td style={S.td}>{a.campaign_name}（{a.platform}）</td>
              <td style={S.td}>{ACTION_NAMES[a.action] || a.action}</td>
              <td style={S.td}>${a.old_budget} → ${a.new_budget}</td>
              <td style={{ ...S.td, fontSize: 12, maxWidth: 320 }}>{a.reason}</td>
              <td style={S.td}>{a.status}</td>
              <td style={{ ...S.td, whiteSpace: 'nowrap' }}>
                {a.status === 'suggested' && (
                  <span style={{ display: 'inline-flex', gap: 6 }}>
                    <button style={S.btnPrimary} onClick={() => act(a.id, 'approve')}>{t('执行')}</button>
                    <button style={S.btn} onClick={() => act(a.id, 'reject')}>{t('拒绝')}</button>
                  </span>
                )}
              </td>
            </tr>
          ))}
          {actions.length === 0 && <tr><td style={S.td} colSpan={6}>{t('暂无建议 — 点击"运行调优引擎"')}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

// ═══ 归因统计 ═══
function AttributionView() {
  const [stats, setStats] = useState<any[]>([]);
  useEffect(() => { get('/api/v1/attribution/stats').then((r: any) => setStats(r.data || [])).catch(() => {}); }, []);

  return (
    <div style={S.card}>
      <h3 style={{ fontSize: 15, marginBottom: 12 }}>{t('广告渠道归因（基于 Shopify 真实订单 UTM）')}</h3>
      <table style={S.table}>
        <thead><tr><th style={S.th}>{t('系列/UTM')}</th><th style={S.th}>{t('来源')}</th><th style={S.th}>{t('订单')}</th><th style={S.th}>{t('收入')}</th></tr></thead>
        <tbody>
          {stats.map((s: any, i: number) => (
            <tr key={i}>
              <td style={S.td}>{s.campaign}</td><td style={S.td}>{s.utm_source}</td>
              <td style={S.td}>{s.orders}</td><td style={{ ...S.td, fontWeight: 700 }}>${(s.revenue || 0).toFixed(0)}</td>
            </tr>
          ))}
          {stats.length === 0 && <tr><td style={S.td} colSpan={4}>{t('暂无归因数据 — 在"广告系列"页执行订单归因')}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

// ═══ 主应用 ═══
function App() {
  const [tab, setTab] = useState('campaigns');
  return (
    <div style={S.page}>
      <div style={{ position: 'fixed', top: 12, right: 16, zIndex: 1000 }}><LanguageSwitcher /></div>
      <h1 style={{ fontSize: 22, marginBottom: 4 }}>AdCampaignAI</h1>
      <p style={{ color: '#666', marginBottom: 16 }}>{t('广告预算自主优化 — Meta/Google 监控 · UTM 归因 · ROAS 调优')}</p>
      <div style={{ display: 'flex', borderBottom: '1px solid #eee', marginBottom: 20 }}>
        <div style={S.tab(tab === 'campaigns')} onClick={() => setTab('campaigns')}>{t('广告系列')}</div>
        <div style={S.tab(tab === 'optimizer')} onClick={() => setTab('optimizer')}>{t('预算调优')}</div>
        <div style={S.tab(tab === 'attribution')} onClick={() => setTab('attribution')}>{t('归因统计')}</div>
        <div style={S.tab(tab === 'settings')} onClick={() => setTab('settings')}>{t('设置')}</div>
      </div>
      {tab === 'campaigns' && <CampaignsView />}
      {tab === 'optimizer' && <OptimizerView />}
      {tab === 'attribution' && <AttributionView />}
      {tab === 'settings' && <SettingsPanel api={{ get: apiGet, post: apiPost, put: apiPut }} />}
    </div>
  );
}

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
